import React from "react";
import { Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import { AUTHENTICATED_ENTRY, APP_PREFIX_PATH } from "configs/AppConfig";
import { protectedRoutes, publicRoutes } from "configs/RoutesConfig";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import AppRoute from "./AppRoute";
import { useSelector } from "react-redux";

// Component to handle initial redirect based on user role
const InitialRedirect = () => {
  const user = useSelector((state) => state.auth.user);
  // Check if current user is Virtual PA - handle both boolean true and string "true"
  const isVirtualPa = user?.role?.virtualPa === true || user?.role?.virtualPa === "true";
  // For Virtual PA users, redirect to customers list, otherwise use default entry
  const redirectPath = isVirtualPa ? `${APP_PREFIX_PATH}/customers` : AUTHENTICATED_ENTRY;
  console.log('InitialRedirect:', { isVirtualPa, redirectPath, userRole: user?.role });
  
  return <Navigate replace to={redirectPath} />;
};

const Routes = () => {
  return (
    <RouterRoutes>
      <Route
        path="/"
        element={<ProtectedRoute />}
      >
        <Route
          path="/"
          element={<InitialRedirect />}
        />
        {protectedRoutes.map((route, index) => {
          return (
            <Route
              key={route.key + index}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          );
        })}
        <Route
          path="*"
          element={
            <Navigate
              to="/"
              replace
            />
          }
        />
      </Route>
      <Route
        path="/"
        element={<PublicRoute />}
      >
        {publicRoutes.map((route) => {
          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          );
        })}
      </Route>
    </RouterRoutes>
  );
};

export default Routes;
